import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './app/reducers';
import { LOCAL_FE_DEV_ENVIRONMENT } from './config';
import { getDummyUser } from './utils/dummyUser';

// A nice helper to tell us if we're on the server
export const isServer = !(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

export default (url = '/') => {
  const enhancers = [];

  // Dev tools are helpful
  if (process.env.NODE_ENV === 'development' && !isServer) {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension());
    }
  }

  const middleware = [thunk];
  const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
  );
  

  // Do we have preloaded state available? Great, save it.
  let initialState = !isServer ? window.__PRELOADED_STATE__ : {};

  // Delete it once we have it stored in a variable
  if (!isServer) {
    delete window.__PRELOADED_STATE__;
  }

  // To make local development easier, we might want to modify the initial state
  if (LOCAL_FE_DEV_ENVIRONMENT) {
    initialState = {
      auth: {
        authenticated: LOCAL_FE_DEV_ENVIRONMENT,
        user: getDummyUser(window.navigator.userAgent) //LOCAL_FE_DEV_USER
      },
      profile: { currentProfile: {} }
    };
  }

  // Create the store
  const store = createStore(rootReducer, initialState, composedEnhancers);

  return {
    store
  };
};